$(function(){
	"use strict";
    equalizeHeight('.press-releases .item-col .item .caption');
	equalizeHeight('.pressroom-highlight .item .caption');
	equalizeHeight('.summary-table .fin  ul > li');
});
$(window).resize(function() {
	"use strict";
   	equalizeHeight('.press-releases .item-col .item .caption');
	equalizeHeight('.pressroom-highlight .item .caption');
	equalizeHeight('.summary-table .fin ul > li');
});

function irMobileNav(){
	 "use strict";
	$('.nav-link.has-nav-menu').click(function(){
		if($('.mob-drop-menu').hasClass('open')){
			$('.mob-drop-menu').removeClass('open');
		}else{
			$('.mob-drop-menu').addClass('open');
		}
		
		return false;
	});
	

}
function initIrOverview(){
    "use strict";
	$(".ir-overview-carousel").slick({
		speed: 500,
		appendDots:$('.ir-overview .slide-dots'),
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows:true,
		autoplay:true,
		autoplaySpeed:3000,
		nextArrow:'<a class="next-slide" href="#"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
		prevArrow:'<a class="prev-slide" href="#"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
		dots: true,		
	});
}

function equalizeHeight(target){
    setTimeout(function(){
        var min_height = 0;
        var tt = $(target);
        tt.css('min-height',0);
        tt.each(function(){
            var t = $(this);
            var adjusted_height = Math.ceil(t.outerHeight() + 1)
            if(adjusted_height > min_height){
                min_height = adjusted_height;
            }
        });

        if(min_height>0){
            tt.css('min-height',min_height);
            tt.css('height','100%');
        }

    },500);
}
function initFilters(){
	"use strict";
	$('body').addClass('list-view');
	$('.filters .layout a').click(function(){
		 equalizeHeight('.press-releases .item-col .item .caption');
		if(!$(this).hasClass('active')){
			$('.filters a.active').removeClass('active');
			$(this).addClass('active');

			if($(this).hasClass('list-view')){
				$('body').addClass('list-view');
				
			}else{
				$('body').removeClass('list-view');
			}
		}
		return false;
	});
	
	$('.filters select').change(function(e){		
		var $this = $(this),		
			key = $this.attr('name'),
			target = $this.data('target'),
			value = $this.val();
		
			if(value === ''){
				$('form[name="' + target + '-nav"] input[name="' + key + '"]').remove();
			}else{
				if($('form[name="' + target + '-nav"] input[name="' + key + '"]').length === 0){
					$('form[name="' + target + '-nav"]').append('<input type="hidden" name="'+key+'" value="'+value+'">');
				}else{
					$('form[name="' + target + '-nav"] input[name="' + key + '"]').val(value);
				}	
			}
		//deepLinking(target);
		filter(target);
		e.preventDefault();
	});
	
	$('.toggle-sort-way').click(function(e){
		var target = $(this).data('target');	
		$('form[name="' + target + '-nav"] input[name="sort_term"]').val($(this).data('name'));
		if ($('form[name="' + target + '-nav"] input[name="sort_way"]').val() === 'DESC') {
			$('form[name="' + target + '-nav"] input[name="sort_way"]').val('ASC');			
		} else {
			$('form[name="' + target + '-nav"] input[name="sort_way"]').val('DESC');			
		}
		$('.toggle-sort-way.active').removeClass('active');
		$('.toggle-sort-way.desc').removeClass('desc');
		$('.toggle-sort-way.asc').removeClass('asc');
		$(this).addClass('active');
		
		if ($('form[name="' + target + '-nav"] input[name="sort_way"]').val() === 'DESC') {
			$(this).addClass('desc');
		} else {
			$(this).addClass('asc');
		}
		
		
		//deepLinking(target);
		filter(target);
		e.preventDefault();
	});
	
}




/*function setEqualHeights(target){
	"use strict";
	var highestBox = 0;
	$(target).css('min-height',0);
    $(target).each(function(){  
		if($(this).height() > highestBox){  
			highestBox = $(this).height();  
        }
    });    
    $(target).css('min-height',highestBox+15);
}
*/
function initHighlight(){
    "use strict";
	
	var carousel = $(".pressroom-highlight .pressroom-highlight-carousel");
	carousel.slick({
		appendDots:$('.pressroom-highlight .slide-dots'),
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		nextArrow:'<a class="next-slide" href="#"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
		prevArrow:'<a class="prev-slide" href="#"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
		dots: true,
		
		responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 3				
			  }
			},
			{
			  breakpoint: 991,
			  settings: {
				slidesToShow: 2				
			  }
			},
			{
			  breakpoint: 550,
			  settings: {
			  slidesToShow: 1,
			  dots: false,
			  arrows: false
				
			  }
			}
		  ]
	});
}